<!-- Navigation -->
<mat-sidenav-container class="tw-min-h-screen tw-w-full">
    <mat-sidenav-content class="">
        <app-navbar [sidenav]="sidenav"></app-navbar>
        <div class="dark:tw-bg-black tw-bg-[#edf2f6] tw-pt-[3.9rem] tw-min-h-screen tw-relative tw-overflow-x-hidden tw-w-full tw-h-full"
            [@routeAnimations]="getRouteAnimationData()">
            @if (isLoading) {
            <loader></loader>
            }
            <router-outlet></router-outlet>
        </div>
        <!-- Site footer, every horizontal-layout page (2026 homepage refresh) -->
        <app-site-footer></app-site-footer>
    </mat-sidenav-content>

    <mat-sidenav #sidenav mode="over" position="start"
        class="tw-w-64 tw-h-screen tw-bg-white dark:tw-bg-gray-800 tw-text-gray-900 dark:tw-text-gray-200">

        <div class="tw-h-full">
            <div
                class="tw-flex tw-justify-between tw-items-center tw-px-2 tw-py-3.5 tw-border-b tw-border-gray-300 dark:tw-border-gray-700">
                <img src="logo/safety-knights-logo.png" class="tw-w-9" alt="Logo" width="36" height="42"
                    (click)="navigateTo('/'); sidenav.close()">
                <h1 class="tw-mb-0 tw-text-xl tw-font-semibold">Safety Knights</h1>
                <button
                    class="tw-text-gray-700 dark:tw-text-gray-300 tw-px-2 tw-rounded hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700"
                    (click)="sidenav.close()" aria-label="Close Sidenav">
                    <i class="fa-solid fa-xmark tw-text-xl"></i>
                </button>
            </div>

            <ul class="tw-p-4">
                @for (nav of navData; track $index) {
                <li class="tw-flex tw-items-center tw-py-2 tw-px-3 tw-mb-1 tw-rounded-lg tw-cursor-pointer tw-transition-all dark:hover:tw-bg-gray-700 hover:tw-bg-gray-200"
                    (click)="navigateTo(nav.routeLink); sidenav.close()" [ngClass]="{ 'tw-hidden': nav.visible }">
                    <i class="fa-solid {{ nav.icon }} tw-mr-3 tw-text-lg tw-w-5"
                        [ngClass]="{ 'tw-hidden': nav.visible }"></i>
                    <div>{{ nav.label }}</div>
                </li>
                }
            </ul>
        </div>

    </mat-sidenav>

</mat-sidenav-container>